(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Ingredient-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function IngredientShowcase(section) {
      this.section = section;
      this.track = section.querySelector('[data-track]');
      this.carousel = section.querySelector('.ingredient-showcase__carousel');
      this.slides = section.querySelectorAll('.ingredient-showcase__slide');
      this.prevBtn = section.querySelector('[data-prev]');
      this.nextBtn = section.querySelector('[data-next]');
      this.dots = section.querySelectorAll('[data-dot]');
      this.tabs = section.querySelectorAll('[data-tab]');
      this.currentIndex = 0;
      this.totalSlides = this.slides.length;

      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchStartTime = 0;
      this.isDragging = false;
      this.directionLocked = false;
      this.isHorizontal = false;

      if (this.totalSlides < 2) return;

      this.bindEvents();
      this.updateState();
    }

    IngredientShowcase.prototype.bindEvents = function () {
      var self = this;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () {
          self.goTo(self.currentIndex - 1);
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () {
          self.goTo(self.currentIndex + 1);
        });
      }

      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(this.getAttribute('data-dot'), 10);
          self.goTo(index);
        });
      });

      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var index = parseInt(this.getAttribute('data-tab'), 10);
          self.goTo(index);
        });
      });

      this.track.addEventListener('touchstart', function (e) {
        self.onTouchStart(e);
      }, { passive: true });

      this.track.addEventListener('touchmove', function (e) {
        self.onTouchMove(e);
      }, { passive: false });

      this.track.addEventListener('touchend', function (e) {
        self.onTouchEnd(e);
      }, { passive: true });

      this.track.addEventListener('touchcancel', function () {
        self.onTouchCancel();
      }, { passive: true });

      this.section.addEventListener('keydown', function (e) {
        self.onKeyDown(e);
      });

      /* CoA Smart Panel toggle */
      this.section.addEventListener('click', function(e) {
        var trigger = e.target.closest('[data-coa-toggle]');
        if (trigger) {
          e.preventDefault();
          trigger.classList.toggle('is-open');
          var body = trigger.nextElementSibling;
          if (body) {
            body.classList.toggle('is-open');
            /* Animate ring stroke-dashoffset when opening */
            if (body.classList.contains('is-open')) {
              var rings = body.querySelectorAll('.coa-panel__ring-fg');
              rings.forEach(function(ring) {
                var targetOffset = ring.getAttribute('data-target-offset');
                if (targetOffset !== null) {
                  ring.style.strokeDashoffset = targetOffset;
                }
              });
            } else {
              var rings = body.querySelectorAll('.coa-panel__ring-fg');
              rings.forEach(function(ring) {
                ring.style.strokeDashoffset = '226';
              });
            }
          }
        }
      });
    };

    IngredientShowcase.prototype.getSlideWidth = function () {
      return this.carousel.offsetWidth;
    };

    IngredientShowcase.prototype.goTo = function (index) {
      if (index < 0 || index >= this.totalSlides) return;
      this.currentIndex = index;
      this.updateState();
    };

    IngredientShowcase.prototype.updateState = function () {
      var offset = -(this.currentIndex * 100);
      this.track.style.transform = 'translateX(' + offset + '%)';

      if (this.prevBtn) {
        this.prevBtn.disabled = this.currentIndex === 0;
      }

      if (this.nextBtn) {
        this.nextBtn.disabled = this.currentIndex === this.totalSlides - 1;
      }

      var self = this;
      this.dots.forEach(function (dot) {
        var dotIndex = parseInt(dot.getAttribute('data-dot'), 10);
        var isActive = dotIndex === self.currentIndex;
        dot.classList.toggle('ingredient-showcase__dot--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.tabs.forEach(function (tab) {
        var tabIndex = parseInt(tab.getAttribute('data-tab'), 10);
        tab.classList.toggle('ingredient-showcase__tab--active', tabIndex === self.currentIndex);
      });
    };

    IngredientShowcase.prototype.onTouchStart = function (e) {
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.touchStartTime = Date.now();
      this.isDragging = true;
      this.directionLocked = false;
      this.isHorizontal = false;
      this.track.style.transition = 'none';
    };

    IngredientShowcase.prototype.onTouchMove = function (e) {
      if (!this.isDragging) return;

      var currentX = e.touches[0].clientX;
      var currentY = e.touches[0].clientY;
      var deltaX = currentX - this.touchStartX;
      var deltaY = currentY - this.touchStartY;

      if (!this.directionLocked) {
        if (Math.abs(deltaX) < 5 && Math.abs(deltaY) < 5) return;
        this.directionLocked = true;
        this.isHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
      }

      if (!this.isHorizontal) {
        this.isDragging = false;
        this.track.style.transition = '';
        return;
      }

      e.preventDefault();

      var slideWidth = this.getSlideWidth();
      var movePercent = (deltaX / slideWidth) * 100;

      var atStart = this.currentIndex === 0 && deltaX > 0;
      var atEnd = this.currentIndex === this.totalSlides - 1 && deltaX < 0;
      if (atStart || atEnd) {
        movePercent *= 0.25;
      }

      var baseOffset = -(this.currentIndex * 100);
      this.track.style.transform = 'translateX(' + (baseOffset + movePercent) + '%)';
    };

    IngredientShowcase.prototype.onTouchEnd = function (e) {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.style.transition = '';

      if (!this.directionLocked || !this.isHorizontal) {
        this.updateState();
        return;
      }

      var deltaX = e.changedTouches[0].clientX - this.touchStartX;
      var elapsed = Date.now() - this.touchStartTime;
      var velocity = Math.abs(deltaX) / elapsed;
      var slideWidth = this.getSlideWidth();

      var swipedEnough = Math.abs(deltaX) > slideWidth * 0.2;
      var flickedFast = velocity > 0.5 && Math.abs(deltaX) > 30;

      if (swipedEnough || flickedFast) {
        if (deltaX < 0) {
          this.goTo(this.currentIndex + 1);
        } else {
          this.goTo(this.currentIndex - 1);
        }
      } else {
        this.updateState();
      }
    };

    IngredientShowcase.prototype.onTouchCancel = function () {
      this.isDragging = false;
      this.track.style.transition = '';
      this.updateState();
    };

    IngredientShowcase.prototype.onKeyDown = function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.goTo(this.currentIndex - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.goTo(this.currentIndex + 1);
      }
    };

    function init() {
      document.querySelectorAll('.ingredient-showcase[data-section-id]').forEach(function (el) {
        if (!el.dataset.initialized) {
          new IngredientShowcase(el);
          el.dataset.initialized = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.ingredient-showcase[data-section-id]');
      if (section) {
        section.removeAttribute('data-initialized');
        new IngredientShowcase(section);
        section.dataset.initialized = 'true';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-ing-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function IngredientShowcase(section) {
      this.section = section;
      this.track = section.querySelector('[data-track]');
      this.carousel = section.querySelector('.ingredient-showcase__carousel');
      this.slides = section.querySelectorAll('.ingredient-showcase__slide');
      this.prevBtn = section.querySelector('[data-prev]');
      this.nextBtn = section.querySelector('[data-next]');
      this.dots = section.querySelectorAll('[data-dot]');
      this.tabs = section.querySelectorAll('[data-tab]');
      this.currentIndex = 0;
      this.totalSlides = this.slides.length;

      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchStartTime = 0;
      this.isDragging = false;
      this.directionLocked = false;
      this.isHorizontal = false;

      if (this.totalSlides < 2) return;

      this.bindEvents();
      this.updateState();
    }

    IngredientShowcase.prototype.bindEvents = function () {
      var self = this;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () {
          self.goTo(self.currentIndex - 1);
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () {
          self.goTo(self.currentIndex + 1);
        });
      }

      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(this.getAttribute('data-dot'), 10);
          self.goTo(index);
        });
      });

      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var index = parseInt(this.getAttribute('data-tab'), 10);
          self.goTo(index);
        });
      });

      this.track.addEventListener('touchstart', function (e) {
        self.onTouchStart(e);
      }, { passive: true });

      this.track.addEventListener('touchmove', function (e) {
        self.onTouchMove(e);
      }, { passive: false });

      this.track.addEventListener('touchend', function (e) {
        self.onTouchEnd(e);
      }, { passive: true });

      this.track.addEventListener('touchcancel', function () {
        self.onTouchCancel();
      }, { passive: true });

      this.section.addEventListener('keydown', function (e) {
        self.onKeyDown(e);
      });

      /* CoA Smart Panel toggle */
      this.section.addEventListener('click', function(e) {
        var trigger = e.target.closest('[data-coa-toggle]');
        if (trigger) {
          e.preventDefault();
          trigger.classList.toggle('is-open');
          var body = trigger.nextElementSibling;
          if (body) {
            body.classList.toggle('is-open');
            /* Animate ring stroke-dashoffset when opening */
            if (body.classList.contains('is-open')) {
              var rings = body.querySelectorAll('.coa-panel__ring-fg');
              rings.forEach(function(ring) {
                var targetOffset = ring.getAttribute('data-target-offset');
                if (targetOffset !== null) {
                  ring.style.strokeDashoffset = targetOffset;
                }
              });
            } else {
              var rings = body.querySelectorAll('.coa-panel__ring-fg');
              rings.forEach(function(ring) {
                ring.style.strokeDashoffset = '226';
              });
            }
          }
        }
      });
    };

    IngredientShowcase.prototype.getSlideWidth = function () {
      return this.carousel.offsetWidth;
    };

    IngredientShowcase.prototype.goTo = function (index) {
      if (index < 0 || index >= this.totalSlides) return;
      var scrollY = this.section.getBoundingClientRect().top + window.pageYOffset;
      this.closeAllCoaPanels();
      this.currentIndex = index;
      this.updateState();
      /* Restore scroll position so page doesn't jump when slides collapse */
      window.scrollTo({ top: scrollY - 20, behavior: 'auto' });
    };

    IngredientShowcase.prototype.closeAllCoaPanels = function () {
      this.section.querySelectorAll('.coa-panel__body').forEach(function (body) {
        body.classList.remove('is-open');
        var ring = body.querySelector('.coa-panel__ring-fg');
        if (ring) ring.style.strokeDashoffset = '226';
      });
      this.section.querySelectorAll('.coa-panel__trigger').forEach(function (trigger) {
        trigger.classList.remove('is-open');
      });
    };

    IngredientShowcase.prototype.updateState = function () {
      var offset = -(this.currentIndex * 100);
      this.track.style.transform = 'translateX(' + offset + '%)';

      if (this.prevBtn) {
        this.prevBtn.disabled = this.currentIndex === 0;
      }

      if (this.nextBtn) {
        this.nextBtn.disabled = this.currentIndex === this.totalSlides - 1;
      }

      var self = this;

      /* Collapse inactive slides so they don't affect track height */
      this.slides.forEach(function (slide, i) {
        if (i === self.currentIndex) {
          slide.style.overflow = '';
          slide.style.height = '';
        } else {
          slide.style.overflow = 'hidden';
          slide.style.height = '0';
        }
      });

      this.dots.forEach(function (dot) {
        var dotIndex = parseInt(dot.getAttribute('data-dot'), 10);
        var isActive = dotIndex === self.currentIndex;
        dot.classList.toggle('ingredient-showcase__dot--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.tabs.forEach(function (tab) {
        var tabIndex = parseInt(tab.getAttribute('data-tab'), 10);
        tab.classList.toggle('ingredient-showcase__tab--active', tabIndex === self.currentIndex);
      });
    };

    IngredientShowcase.prototype.showAllSlides = function () {
      this.slides.forEach(function (slide) {
        slide.style.overflow = '';
        slide.style.height = '';
      });
    };

    IngredientShowcase.prototype.onTouchStart = function (e) {
      /* Don't treat CoA panel interactions as swipe */
      if (e.target.closest('[data-coa-toggle]') || e.target.closest('.coa-panel__body')) return;
      this.showAllSlides();
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.touchStartTime = Date.now();
      this.isDragging = true;
      this.directionLocked = false;
      this.isHorizontal = false;
      this.track.style.transition = 'none';
    };

    IngredientShowcase.prototype.onTouchMove = function (e) {
      if (!this.isDragging) return;

      var currentX = e.touches[0].clientX;
      var currentY = e.touches[0].clientY;
      var deltaX = currentX - this.touchStartX;
      var deltaY = currentY - this.touchStartY;

      if (!this.directionLocked) {
        if (Math.abs(deltaX) < 5 && Math.abs(deltaY) < 5) return;
        this.directionLocked = true;
        this.isHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
      }

      if (!this.isHorizontal) {
        this.isDragging = false;
        this.track.style.transition = '';
        return;
      }

      e.preventDefault();

      var slideWidth = this.getSlideWidth();
      var movePercent = (deltaX / slideWidth) * 100;

      var atStart = this.currentIndex === 0 && deltaX > 0;
      var atEnd = this.currentIndex === this.totalSlides - 1 && deltaX < 0;
      if (atStart || atEnd) {
        movePercent *= 0.25;
      }

      var baseOffset = -(this.currentIndex * 100);
      this.track.style.transform = 'translateX(' + (baseOffset + movePercent) + '%)';
    };

    IngredientShowcase.prototype.onTouchEnd = function (e) {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.style.transition = '';

      if (!this.directionLocked || !this.isHorizontal) {
        this.updateState();
        return;
      }

      var deltaX = e.changedTouches[0].clientX - this.touchStartX;
      var elapsed = Date.now() - this.touchStartTime;
      var velocity = Math.abs(deltaX) / elapsed;
      var slideWidth = this.getSlideWidth();

      var swipedEnough = Math.abs(deltaX) > slideWidth * 0.2;
      var flickedFast = velocity > 0.5 && Math.abs(deltaX) > 30;

      if (swipedEnough || flickedFast) {
        if (deltaX < 0) {
          this.goTo(this.currentIndex + 1);
        } else {
          this.goTo(this.currentIndex - 1);
        }
      } else {
        this.updateState();
      }
    };

    IngredientShowcase.prototype.onTouchCancel = function () {
      this.isDragging = false;
      this.track.style.transition = '';
      this.updateState();
    };

    IngredientShowcase.prototype.onKeyDown = function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.goTo(this.currentIndex - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.goTo(this.currentIndex + 1);
      }
    };

    function init() {
      document.querySelectorAll('.ingredient-showcase[data-section-id]').forEach(function (el) {
        if (!el.dataset.initialized) {
          new IngredientShowcase(el);
          el.dataset.initialized = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.ingredient-showcase[data-section-id]');
      if (section) {
        section.removeAttribute('data-initialized');
        new IngredientShowcase(section);
        section.dataset.initialized = 'true';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredientsall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function CsAll(section) {
      this.section = section;
      this.tabs = section.querySelectorAll('[data-product-tab]');
      this.groups = section.querySelectorAll('[data-product-group]');

      this.bindProductTabs();
      this.bindCoaToggle();
    }

    CsAll.prototype.bindProductTabs = function () {
      var self = this;
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          self.switchProduct(this.getAttribute('data-product-tab'));
        });
      });
    };

    CsAll.prototype.switchProduct = function (handle) {
      this.tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-product-tab') === handle;
        tab.classList.toggle('cs-all__product-tab--active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.groups.forEach(function (group) {
        var match = group.getAttribute('data-product-group') === handle;
        if (match) {
          group.removeAttribute('hidden');
        } else {
          group.setAttribute('hidden', '');
          // Collapse any open CoA panels in the hidden group
          group.querySelectorAll('.coa-panel__body.is-open').forEach(function (b) { b.classList.remove('is-open'); });
          group.querySelectorAll('.coa-panel__trigger.is-open').forEach(function (t) { t.classList.remove('is-open'); });
        }
      });
    };

    CsAll.prototype.bindCoaToggle = function () {
      this.section.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-coa-toggle]');
        if (!trigger) return;
        e.preventDefault();
        trigger.classList.toggle('is-open');
        var body = trigger.nextElementSibling;
        if (!body) return;
        body.classList.toggle('is-open');
        if (body.classList.contains('is-open')) {
          body.querySelectorAll('.coa-panel__ring-fg').forEach(function (ring) {
            var t = ring.getAttribute('data-target-offset');
            if (t !== null) ring.style.strokeDashoffset = t;
          });
        } else {
          body.querySelectorAll('.coa-panel__ring-fg').forEach(function (ring) {
            ring.style.strokeDashoffset = '226';
          });
        }
      });
    };

    function init() {
      document.querySelectorAll('.ingredient-showcase--all[data-section-id]').forEach(function (el) {
        if (!el.dataset.initialized) {
          new CsAll(el);
          el.dataset.initialized = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.ingredient-showcase--all[data-section-id]');
      if (section && !section.dataset.initialized) {
        new CsAll(section);
        section.dataset.initialized = 'true';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
